export default __webpack_public_path__ + "static/media/logo-ul-black.669dbdfb.png";